import { backOffExponential } from '@epilot/journey-logic-commons/src/utils/backOff'
import { QueryCache, QueryClient } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { isNetworkOrIdempotentRequestError } from 'axios-retry'

export const RETRIES_ALLOWED = 3

export const retryAllowed = (retries: number, error: unknown) => {
  return (
    retries <= RETRIES_ALLOWED &&
    // and either not an axios error or is a retryable error
    (!isAxiosError(error) || isNetworkOrIdempotentRequestError(error))
  )
}

export const retryDelay = (retries: number) => {
  return backOffExponential(1_000, retries + 1, 30_000)
}

/**
 * Cached instance of the {@link QueryClient} used within the App.
 * Gets created as soon as this file is imported for the first time.
 */
const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: retryAllowed,
      retryDelay
    }
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.errorMessage) {
        // eslint-disable-next-line no-console
        console.error(query.meta.errorMessage, error)
      }
    }
  })
})

export const getQueryClient = () => client
